'use client';
import { jsx } from 'react/jsx-runtime';
import { mergeProps } from '@zag-js/react';
import { forwardRef } from 'react';
import { createSplitProps } from '../create-split-props.mjs';
import { ark } from '../factory.mjs';
import { useTabsContext } from './tabs-context.mjs';

const TabTrigger = forwardRef((props, ref) => {
  const [tabProps, buttonProps] = createSplitProps()(props, ["disabled", "value"]);
  const api = useTabsContext();
  const mergedProps = mergeProps(api.getTriggerProps(tabProps), buttonProps);
  return /* @__PURE__ */ jsx(ark.button, { ...mergedProps, ref });
});
TabTrigger.displayName = "TabTrigger";

export { TabTrigger };
